module.exports = __webpack_public_path__ + "img/10-7.9ed321cf.jpg";